if (jQuery(window).width() < 640) {
    jQuery('#featuresContainer').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        centerMode: true,
        centerPadding: '0',
        rows: 0,
        prevArrow: jQuery("#featuresPrev"),
        nextArrow: jQuery("#featuresNext")
    })
}